// - src/plugins/fieldFormatter.js
const VueTranslator = {
  install(Vue, options) {
    const terms = options;
    const translator = (term) => {
        if (terms[term]) return terms[term];
        return term;
    }
    
    /**
     * Global Vue method
     * Usage: this.$translate('translation-term') or
     *        <div :placeholder="$translate('translation-term')"
     */
    Vue.prototype.$translate = translator,
    
    /**
     * Directive
     * Usage: <div v-translate>translation-term</div>
     */
    Vue.directive('translate', {
      bind(el, binding, vnode, oldVnode) {
        const term = el.innerHTML;
        el.innerHTML = translator(term);
      }
    }),
    
    /**
     * Filter
     * Usage: <div>{{ 'translation-term' | translate }}</div>
     */
    Vue.filter('translate', translator)
    
  },
};

export default VueTranslator;


// WEBPACK FOOTER //
// ./src/plugins/VueTranslator.js